import React, {Component, Fragment} from 'react';
import { compose } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { Grid } from '@material-ui/core';
import { getAllGuests, getGuestById, deleteGuestById } from "store/state/guest";
import { getAllGuestGroups, getGuestGroupById, deleteGuestGroupById } from "store/state/guestGroup";
import {ToastError} from "components/Global/Toasts/Toasty";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';

import GuestHeader from './Header';
import GuestGroupsTable from "../util/GuestGroupsTable";
import GuestTable from "../util/GuestTable";
import {initialState, radioOptions} from "../util/common";

class GuestPermissionsPage extends Component{
    state = initialState;

    static getDerivedStateFromProps(props, state) {
        if (props.guestsFoundCount !== state.guestsFoundCount || props.guestGroupsFoundCount !== state.guestGroupsFoundCount) {
          return {
            guestsFoundCount: props.guestsFoundCount,
            guestGroupsFoundCount: props.guestGroupsFoundCount,
            guestRecords: props.guests,
            guestGroups: props.guestGroups,
            allGuestGroups: props.guestGroups
          };
        }
        return null;
    }

    componentDidMount(){
        this.props.getAllGuests({includeAuxData: true});
        this.props.getAllGuestGroups();
    }

    handleChange = (name, value) => {
        switch (name) {
            case "viewByValue":
                this.setState({[name]: value, isGuestGrid: value === "0"});
                break;
            case "guestFilterText":
                const filteredRecords = this.filterRecords(value);
                this.setState({ [name]: value, guestRecords: filteredRecords });
                break;
            case "guestGroupFilterText":
                const filteredGuestGroups = this.props.guestGroups.filter(guestGroup => guestGroup.name.toUpperCase().includes(value.toUpperCase()));
                this.setState({ [name]: value, guestGroups: filteredGuestGroups });
                break;
            default:
                break;
        }
    }

    deleteGuest= (guest) => this.setState({guestFilterText: "", guestToDelete: guest, isCancelModalOpen: true})

    closeCancelModal = () => this.setState({isCancelModalOpen: false})


      filterRecords = (searchName) => {
        const { guests } = this.props;
        // filter the matching records from all
        const filteredRecords = guests.filter((record) => {
            const searchValue = searchName ? searchName.toLowerCase() : '';
            const firstNameFilter = record.contact.firstName ? record.contact.firstName.toLowerCase().indexOf(searchValue) > -1 : false;
            const lastNameFilter = record.contact.lastName ? record.contact.lastName.toLowerCase().indexOf(searchValue) > -1 : false;
            const companyFilter = record.contact.company.name ? record.contact.company.name.toLowerCase().indexOf(searchValue) > -1 : false;
            return firstNameFilter || lastNameFilter || companyFilter;
        });

        return filteredRecords;
      }
  deleteGuestGroup = guestGroup => {
    this.props.deleteGuestGroupById({ id: guestGroup.id });
  };

    render() {
      const { guestRecords, guestToDelete} = this.state;

        return (
        <Fragment>
            <GuestHeader
                guestFilterText={this.state.guestFilterText}
                guestGroupFilterText={this.state.guestGroupFilterText}
                handleChange={this.handleChange}
                viewByValue={this.state.viewByValue}
                options={radioOptions}
                />

            <Grid container style={{ width: "100%", rightPadding: 10 }}>
                <Grid item style={{ width: "100%" }}>
                    {this.state.isGuestGrid && <GuestTable
                            records={guestRecords}
                            deleteGuest={this.deleteGuest}
                            />}
                    {!this.state.isGuestGrid && <GuestGroupsTable
                            guestGroups={this.state.guestGroups}
                            deleteGuestGroup={this.deleteGuestGroup}
                            />}
                </Grid>
            </Grid>

            <SimpleConfirmDialog
                title="Confirm Delete"
                message={`You are about to remove access for ${!guestToDelete.contact ? '' : guestToDelete.contact.firstName } ${!guestToDelete.contact ? '' : guestToDelete.contact.lastName} as a guest. This will remove him/her from all assigned groups and deals. Are you sure you want to do this?`}
                noText="NO"
                yesText="YES, DELETE"
                modalOpen={this.state.isCancelModalOpen}
                handleNo={this.closeCancelModal}
                handleYes={() => {
                    this.props.deleteGuestById({guestId: guestToDelete.id});
                    this.setState({isCancelModalOpen: false});
                }} />
        </Fragment>
        );
    }

}

function mapStateToProps({guest, guestGroup}) {
    return {
        guests: guest.guests,
        guestGroups: guestGroup.guestGroups,
        guestsFoundCount: guest.guests.length,
        guestGroupsFoundCount: guestGroup.guestGroups.length,
    }
 }

export default compose(

    connect( mapStateToProps,
            {
              getAllGuests,
              getGuestById,
              deleteGuestById,
              getAllGuestGroups,
              getGuestGroupById,
              deleteGuestGroupById
            }
           ),
)(GuestPermissionsPage);